import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthMethodModel } from '../models/auth-method.model';

import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthMethodIsAllowedGuard implements CanActivate {
  /**
   *
   * @param {AuthService} authService
   * @param {Router} router
   */
  public constructor(
    private authService: AuthService,
    private router: Router,
  ) { }

  /**
   * Check if a route can be accessed
   *
   * @param {ActivatedRouteSnapshot} next
   * @param {RouterStateSnapshot} state
   *
   * @return {Observable<any>}
   */
  public canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    const idp = next.params['idp'] ? next.params['idp'] : 'athand';
    return this.authService.getAllowedAuthMethods().pipe(
      map((auth_methods: AuthMethodModel[]) => {
        return auth_methods.map((authMethod: AuthMethodModel) => {
          return authMethod.idp;
        }).includes(idp) ? true : this.router.navigate(['/']).then();
      }),
    );
  }
}
